import React from 'react';
import {Link} from 'react-router';
import moment from 'moment'



class Contract  extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      name: this.props.contract.name,
      school: this.props.contract.school,
      signing_date: this.props.contract.signing_date,
      id: this.props.contract.id,
      creation_time: this.props.contract.creation_time
    }
  }

  render() {
    return (
      <div className='contract-container'>
        <h4>{this.state.name}</h4>
        <p>{this.state.school}</p>
        <p>{this.state.signing_date}</p>
        <p>{moment(this.state.creation_time).format('DD-MM-YYYY')}</p>
      </div>
    )
  } 

}

export default Contract;


// WEBPACK FOOTER //
// ./src/components/list/Contract.js